import styles from './styles';
import { hooks } from 'mage-i18n';
import { useHelpContext } from '../../hooks';
import React, { useState, useEffect } from 'react';
import { IconSpeechBubble, ButtonPrimary } from '@klarna/bubble-ui';
const SUPPORT_HELPBOT = 'supportHelpbot';
const GetSupportFloatingButton = () => {
    // @ts-ignore
    const { navigation, isOpen, isFloatingButtonEnabled } = useHelpContext();
    const t = hooks.useTranslator();
    const [isButtonVisible, setButtonVisible] = useState(true);
    useEffect(() => {
        setButtonVisible(!isOpen);
    }, [navigation.activePage.path]);
    const handleClick = () => {
        navigation.push(SUPPORT_HELPBOT);
    };
    if (!isFloatingButtonEnabled)
        return React.createElement(React.Fragment, null);
    return (isButtonVisible && (React.createElement("div", { style: styles.chatWidget },
        React.createElement(ButtonPrimary, { onClick: handleClick, size: 'medium', icon: IconSpeechBubble }, t('help-tool.support-button')))));
};
export default GetSupportFloatingButton;
